// extracted by mini-css-extract-plugin
module.exports = {"gif":"x_bG","gif--wrapped":"x_bH"};